import { useState } from 'react';
import { FilterStrategy, FilterType } from '../data/Filter';
import { FilterByPos } from '../filters/filterByPos';
import type { ReactSetState } from '../utils/types';
import { ContextProviderProps, createContext } from '../common/contextFactory';

type FiltersProps = {
    filtersChanged: boolean,
    setFiltersChanged: ReactSetState<boolean>,
    showFilters: boolean;
    setShowFilters: ReactSetState<boolean>;
    filterStrategies: FilterStrategy[];
    filterCounter: number;
    setFilterCounter: ReactSetState<number>;
}

const [useFiltersContext, Provider] = createContext<FiltersProps>('FiltersCtx');

const useInitFiltersContext = () => {
    const [showFilters, setShowFilters] = useState<boolean>(false)
    const [filtersChanged, setFiltersChanged] = useState<boolean>(false)
    const [filterStrategies] = useState<FilterStrategy[]>([{
        name: FilterType.posOnly,
        implementation: new FilterByPos()
    }])
    const [filterCounter, setFilterCounter] = useState<number>(0);

    const filtersProps: FiltersProps = {
        filtersChanged,
        setFiltersChanged,
        showFilters,
        setShowFilters,
        filterStrategies,
        filterCounter,
        setFilterCounter
    };
    return filtersProps;
};

const FiltersContextProvider = ({ children }: ContextProviderProps) => {
    return <Provider value={useInitFiltersContext()}>
        {children}
    </Provider>;
};

export { useFiltersContext, FiltersContextProvider };